import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FiAlertCircle, FiBookOpen, FiArrowRight } from 'react-icons/fi';
import CustomLoader from '../../components/CustomLoader';

const Blogs = () => {
  const [loading, setLoading] = useState(true);
  const [blogs, setBlogs] = useState([]);
  const navigate = useNavigate();
  const token = useSelector((state) => state.user?.currentUser?.token);

  // Dummy blog data with empty picture field
  const dummyBlogs = [
    {
      _id: '1',
      title: 'Mastering JavaScript in 2025',
      desc: 'Explore the latest JavaScript features and best practices to build modern web applications.',
      picture: 'https://media.istockphoto.com/id/615422436/photo/demo-sign-cubes.jpg?s=612x612&w=0&k=20&c=HHOLIiF8SmbIssxKv3G480EgTVub_v9cc1QME3Dn6XU=',
    },
    {
      _id: '2',
      title: 'Top 10 Tips for Acing Coding Interviews',
      desc: 'Learn expert strategies to prepare for technical interviews and land your dream job.',
      picture: 'https://media.istockphoto.com/id/615422436/photo/demo-sign-cubes.jpg?s=612x612&w=0&k=20&c=HHOLIiF8SmbIssxKv3G480EgTVub_v9cc1QME3Dn6XU=',
    },
    {
      _id: '3',
      title: 'Why Learn Python for Data Science?',
      desc: 'Discover why Python is the go-to language for data science and how to get started.',
      picture: 'https://media.istockphoto.com/id/615422436/photo/demo-sign-cubes.jpg?s=612x612&w=0&k=20&c=HHOLIiF8SmbIssxKv3G480EgTVub_v9cc1QME3Dn6XU=',
    },
  ];

  useEffect(() => {
    window.scrollTo(0,0)
    const getAllBlogs = async () => {
      setLoading(true);
      try {
        // Simulate API call with dummy data
        setTimeout(() => {
          setBlogs(dummyBlogs);
          setLoading(false);
        }, 1000);
      } catch (err) {
        console.log(err);
        setLoading(false);
      }
    };
    getAllBlogs();
  }, [token]);

  return (
    <div className="min-h-screen bg-gradient-to-r from-[#f6f2fa] to-[#dceefe] py-12">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl h-fit md:text-5xl font-bold text-center mb-5 text-gray-600">
          Explore Our Blogs
        </h1>

        {loading ? (
          <CustomLoader loading='Loading blogs...' />
        ) : blogs.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {blogs.map((blog) => (
              <div
                key={blog._id}
                className="group bg-white rounded-xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-2xl hover:-translate-y-1"
              >
                <div className="relative">
                  <img
                    src={blog.picture || 'https://via.placeholder.com/300x200?text=Blog+Image'}
                    alt={blog.title}
                    className="w-full h-48 object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                    <FiArrowRight className="text-white text-4xl" />
                  </div>
                </div>
                <div className="p-6">
                  <h2 className="font-semibold text-gray-900 mb-2">
                    {blog.title}
                  </h2>
                  <p className="text-gray-600 text-sm mb-4 line-clamp-2">{blog.desc}</p>
                  <button
                    onClick={() => navigate(`/blog/${blog._id}`)}
                    className="w-full bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white px-4 py-2 rounded-lg font-semibold transition duration-300"
                  >
                    Read More
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center min-h-[50vh] bg-white rounded-xl shadow-lg p-8">
            <FiAlertCircle className="text-red-500 text-6xl mb-4" />
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">No Blogs Available</h2>
            <p className="text-gray-600 text-center mb-6">
              It looks like there are no blogs to show right now. Check back later or explore our courses!
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/courses"
                className="flex items-center gap-2 bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white px-6 py-3 rounded-lg font-semibold transition duration-300"
              >
                <FiBookOpen size={20} />
                Explore Courses
              </Link>
              <Link
                to="/"
                className="flex items-center gap-2 bg-gradient-to-r from-[#f1bb65] to-[#f2884a] hover:from-[#f0a540] hover:to-[#f07a3a] text-white px-6 py-3 rounded-lg font-semibold transition duration-300"
              >
                <FiArrowRight size={20} />
                Back to Home
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Blogs;